import React, { useState, useRef, useEffect } from 'react';
import { getImgPath, handleImgError } from '../helper';
const EditAutocomplete = (props) => {
    const wrapperRef = useRef(null);
    const { options, type, label, selVal, onClick, handlePickDrop, openDrop, setOpenPickupDrop, setOpenDropOffDrop } = props;


    useEffect(() => {
        const handleClickOutside = (event) => {
            if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
                setOpenPickupDrop && setOpenPickupDrop(false);
                setOpenDropOffDrop && setOpenDropOffDrop(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    return (
        <div className="autocomplete" ref={wrapperRef} style={type === 'pickup' ? { marginRight: '16px' } : {}}>
            <div className='pick--drop-inp-wrap'>
                <div className='pick--drop--input' onClick={onClick}>{selVal}</div>
                <div className='pick--drop--label'>{label}</div>
                <div className='pick--drop--icon'><img src={getImgPath('/img/inpdropIcon.png')} onError={handleImgError} /></div>
            </div>
            {openDrop &&
                <div className='pick--drop--content'>
                    {options.length > 0 &&
                        options.map((el) => (
                            <div className={`drop--item ${selVal === el.name ? 'active' : ''}`} onClick={() => handlePickDrop(el.id, el.name, type)} key={el.id}>
                                {el.name}
                            </div>
                        ))
                    }
                </div>
            }
        </div>
    );
};

export default EditAutocomplete;
